<template>
  <v-container>
    <v-row>
      <v-col lg="5" md="12">
        <v-card class="card" color="secondary" elevation="8">
          <v-card-title class="font-weight-bold black--text justify-center mb-5">
            Información de evaluaciones de desempeño
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-icon color="primary" left>mdi-calendar</v-icon>
                <span class="font-weight-bold black--text">Fecha evaluación de desempeño académico:</span>
                <span class="ml-2 black--text">
                  {{ latestEvaluacionAcademicaDate ? formatFecha(latestEvaluacionAcademicaDate) : 'Sin registro' }}
                </span>
              </v-col>
              <v-col cols="12">
                <v-icon color="primary" left>mdi-note-check</v-icon>
                <span class="font-weight-bold black--text">Calificación evaluación de desempeño académico:</span>
                <span class="ml-2 black--text">{{ latestEvaluacionAcademicaCalificacion || 'Sin registro' }}</span>
              </v-col>
            </v-row>
            <v-divider class="my-4 mx-0"></v-divider>
            <v-row>
              <v-col cols="12">
                <v-icon color="primary" left>mdi-calendar-check</v-icon>
                <span class="font-weight-bold black--text">Fecha evaluación de desempeño:</span>
                <span class="ml-2 black--text">
                  {{ latestEvaluacionDesempenioDate ? formatFecha(latestEvaluacionDesempenioDate) : 'Sin registro' }}
                </span>
              </v-col>
              <v-col cols="12">
                <v-icon color="primary" left>mdi-note-check</v-icon>
                <span class="font-weight-bold black--text">Calificación evaluación de desempeño:</span>
                <span class="ml-2 black--text">{{ latestEvaluacionDesempenioCalificacion || 'Sin registro' }}</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg="7" md="12">
        <v-card class="card mx-2" color="primary">
          <v-card-title class="font-weight-bold justify-center">Asignación de CUP</v-card-title>
          <v-card-text>
            <v-text-field
              :value="getFullName(personal)"
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
              label="Nombre del elemento"
              :rules="nameRules"
              readonly
            ></v-text-field>
            <v-text-field
              :value="personal ? personal.CUIP : ''"
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
              label="CUIP"
              :rules="nameRules"
              readonly
            ></v-text-field>
            <v-text-field
              v-model="cup"
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
              label="CUP"
              :rules="nameRules"
            >
              <template v-slot:label>Ingrese número de CUP <span class="red--text">*</span> </template>
            </v-text-field>
            <v-file-input
              v-model="file"
              rounded
              filled
              background-color="primary"
              color="secondary"
              dense
              accept=".pdf"
              :rules="nameRules"
            >
              <template v-slot:label>Adjuntar documento CUP <span class="red--text">*</span> </template>
            </v-file-input>
            <v-text-field
              v-model="vigenciaEvaluacionC3"
              v-mask="'##/##/####'"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              :rules="dateRules"
            >
              <template v-slot:label>Fecha de emisión de evaluaciones C3 <span class="red--text">*</span> </template>
            </v-text-field>
            <v-text-field
              v-model="vigenciaFormacionInicial"
              v-mask="'##/##/####'"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              :rules="dateRules"
            >
              <template v-slot:label>Fecha de emisión de formación inicial <span class="red--text">*</span> </template>
            </v-text-field>
            <v-text-field
              v-model="vigenciaCompetenciasBasicas"
              v-mask="'##/##/####'"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              :rules="dateRules"
            >
              <template v-slot:label
                >Fecha de emisión de competencias básicas <span class="red--text">*</span>
              </template>
            </v-text-field>
            <v-text-field
              v-model="vigenciaCup"
              v-mask="'##/##/####'"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              :rules="dateRules"
            >
              <template v-slot:label>Fecha de emisión de CUP <span class="red--text">*</span> </template>
            </v-text-field>
          </v-card-text>
          <v-card-actions class="justify-center pb-8">
            <v-btn v-bind="secondaryButtonProps" to="/desarrollo_profesional/personal">Cancelar</v-btn>
            <v-btn v-bind="primaryButtonProps" v-on:click="asignaCup()" :loading="loading" :disabled="loading"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { primaryButtonProps, secondaryButtonProps } from '../../components/props/props'

export default {
  props: {
    personal: {
      type: Object,
    },
  },

  data() {
    return {
      primaryButtonProps,
      secondaryButtonProps,
      loading: false,
      cup: '',
      file: null,
      vigenciaEvaluacionC3: this.personal ? this.personal.vigenciaEvaluacionC3 : '',
      vigenciaFormacionInicial: this.personal ? this.personal.vigenciaFormacionInicial : '',
      vigenciaCompetenciasBasicas: this.personal ? this.personal.vigenciaCompetenciasBasicas : '',
      vigenciaCup: this.personal ? this.personal.vigenciaCup : '',
      nameRules: [(v) => !!v || 'Este campo es requerido.'],
      dateRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => {
          var date = moment(v, 'DD/MM/YYYY')
          return moment(date, 'DD/MM/YYYY').isValid() || 'El formato de fecha debe ser DD/MM/YYYY'
        },
      ],
    }
  },
  computed: {
    ...mapGetters('respetoPrincipios', {
      latestEvaluacionDesempenioDate: 'getLatestEvaluacionDesempenioDate',
      latestEvaluacionDesempenioCalificacion: 'getLatestEvaluacionDesempenioCalificacion',
    }),
    ...mapGetters('respetoPrincipiosValores', {
      latestEvaluacionAcademicaDate: 'getLatestEvaluacionAcademicaDate',
      latestEvaluacionAcademicaCalificacion: 'getLatestEvaluacionAcademicaCalificacion',
    }),
  },

  async mounted() {
    if (this.personal && this.personal.idPersonal) {
      await this.fetchRespetoPrincipios(this.personal.idPersonal)
      await this.fetchRespetoPrincipiosValores(this.personal.idPersonal)
    }
  },

  methods: {
    ...mapActions('personal', ['updateCupPersonal', 'fetchPersonal', 'updatePersonal', 'uploadCup']),
    ...mapActions('respetoPrincipios', ['fetchRespetoPrincipios']),
    ...mapActions('respetoPrincipiosValores', ['fetchRespetoPrincipiosValores']),

    asignaCup: async function () {
      this.loading = true
      this.personal.cup = this.cup
      await this.updateCupPersonal(this.personal)

      var formData = new FormData()
      formData.append('file', this.file)
      formData.append('idPersonal', this.personal.idPersonal)
      await this.uploadCup(formData)

      this.personal.vigenciaEvaluacionC3 = this.vigenciaEvaluacionC3
      this.personal.vigenciaFormacionInicial = this.vigenciaFormacionInicial
      this.personal.vigenciaCompetenciasBasicas = this.vigenciaCompetenciasBasicas
      this.personal.vigenciaCup = this.vigenciaCup

      await this.updatePersonal(this.personal)

      this.$router.push('/desarrollo_profesional/personal')
      this.loading = false
    },
    getFullName(personal) {
      if (!personal) return ''
      return `${personal.apaterno} ${personal.amaterno} ${personal.nombre} ${personal.segundoNombre}`
    },
    formatFecha(fecha) {
      if (!fecha) return 'Sin registro'
      if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
        return moment(fecha, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(fecha)) {
        return moment(fecha, 'DD/MM/YYYY').format('DD/MM/YYYY')
      }
      return 'Sin registro'
    },
  },
}
</script>
